import React, { createContext, useState } from 'react'

// Extension of createContext that returns a value and a setter
// https://github.com/streamich/react-use/issues/247

// type StateContextValue<T> = [T, React.Dispatch<React.SetStateAction<T>>]

// interface StateContextProviderProps<T> {
//   value?: T
//   children: ReactNode
// }

function createStateContext(initialValue) {
  const context = createContext([initialValue, () => {}])
  const InnerProvider = context.Provider

  function Provider({ value, children, ...rest }) {
    const state = useState(value !== undefined ? value : initialValue)
    return React.createElement(InnerProvider, { value: state, ...rest }, children)
  }

  // Override the Provider property
  context.Provider = Provider
  
  return context
}

export default createStateContext